var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"toasty"},[_c('transition-group',{attrs:{"name":"message","tag":"ul"}},_vm._l((_vm.toasts),function(toast){return _c('toast',{key:toast._id,attrs:{"toast":toast,"remove":_vm.remove}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }